<template>
    <div class="page-content">
        <LoadingOverlay></LoadingOverlay>
    </div>
</template>

<script setup lang="ts">
import LoadingOverlay from "./LoadingOverlay.vue";
</script>
